"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  padding: 10px;\n  padding-left: 0;\n  align-items: center;\n\n  p {\n    font-family: ", ";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 21px;\n    letter-spacing: -0.015em;\n    color: ", ";\n    flex: 1;\n    text-align: center;\n\n    &.value-header {\n      max-width: 60px;\n    }\n\n    &.image-header {\n      max-width: 60px;\n    }\n\n    &.image-name {\n      min-width: 20%;\n    }\n\n    &.image-format {\n      max-width: 60px;\n    }\n\n    &.image-size {\n      max-width: 90px;\n    }\n\n    &.image-identifier {\n      max-width: 80px;\n    }\n\n    &.image-description {\n      max-width: 120px;\n    }\n  }\n"])), _variables.FontFamily.AvenirNext, _variables.GlobalColors.s5);

exports.Container = Container;